module.exports = __webpack_public_path__ + "img/Feria del Trabajo 2026_Banner redesy feria.16e8ae6d.jpg";